import {
  GET_TESTCENTERS,
  SET_MAP,
  UPDATE_TESTCENTER,
  GET_TESTCENTER,
  DELETE_TESTCENTER,
} from "../actions/types";

const initialState = {
  testcenters: [],
  testcenter: {},
  zoom: [11],
  center: [-110.926389, 32.221667],
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TESTCENTERS:
      return {
        ...state,
        testcenters: payload,
        zoom: [11],
      };
    case GET_TESTCENTER:
    case UPDATE_TESTCENTER:
      return {
        ...state,
        testcenter: payload,
      };
    case DELETE_TESTCENTER:
      return {
        ...state,
        testcenters: state.testcenters.filter(
          (testcenter) => testcenter._id !== payload
        ),
      };
    case SET_MAP:
      return {
        ...state,
        zoom: [14],
        center: payload,
      };
    default:
      return state;
  }
}
